<nav #navbar class="ourApp navbar-default navbar-fixed-top" role="navigation" >
    <table width="100%">
        <tr>
            <td>
                <button class="btn-c" type="button" (click)="close()">
                        <img src="assets/images/close.png" alt="close">
                </button>
            </td>
            <td>
                <span>
                    Télécharger notre Appllication
                </span>
            </td>
            <td>
                <a *ngIf="url == 'android' && android" class="url" href="https://play.google.com/store/apps/details?id={{android}}"
                    target="_blank" (click)="close()">
                    <img src="assets/images/android.png" alt="application android">
                </a>
                <a *ngIf="url == 'iPhone' && ios" class="url" href="https://apps.apple.com/fr/app/{{ios}}" target="_blank" (click)="close()">
                    <img src="assets/images/ios.png" alt="application ios">
                </a>
            </td>
        </tr>
    </table>
</nav>